// gfaLayerIds — GFA hazard-layer constants shared between MapView.tsx and
// src/map/layers/gfa.ts.
//
// These were previously defined in MapView.tsx, but gfa.ts imported them
// from there while being itself a transitive dependency of MapView.tsx
// (MapView → addOverlays → gfa → MapView). That circular import caused a
// Temporal Dead Zone (TDZ) ReferenceError on cold page load in ES module
// environments (native browser ESM dev mode): gfa.ts accesses GFA_LAYER_IDS
// at module-level inside registerLayerFamily({layerIds: GFA_LAYER_IDS}),
// but at that point MapView.tsx had not finished executing so GFA_LAYER_IDS
// was still in the TDZ.
//
// Fix: extract the constants here (no circular dep). Both MapView.tsx and
// gfa.ts import from this standalone module.
//
// Introduced by the HI-2 step 2d cold-boot fix (2026-05-24).

/** Maps every GFA MapLibre layer id → its hazard-type string used as a
 *  GeoJSON feature property value. The keys drive the full list of GFA
 *  layers; the values drive filter expressions. */
export const HAZARD_BY_LAYER: Record<string, string> = {
  'gfa-ifr-fill': 'IFR',           'gfa-ifr-line': 'IFR',
  'gfa-mtnobscn-fill': 'MT_OBSC',  'gfa-mtnobscn-line': 'MT_OBSC',
  'gfa-ice-fill': 'ICE',           'gfa-ice-line': 'ICE',          'gfa-ice-label': 'ICE',
  'gfa-turblo-fill': 'TURB-LO',    'gfa-turblo-line': 'TURB-LO',   'gfa-turblo-label': 'TURB-LO',
  'gfa-turbhi-fill': 'TURB-HI',    'gfa-turbhi-line': 'TURB-HI',   'gfa-turbhi-label': 'TURB-HI',
  'gfa-llws-fill': 'LLWS',         'gfa-llws-line': 'LLWS',
  'gfa-fzlvl-line': 'FZLVL',       'gfa-fzlvl-label': 'FZLVL',
  'gfa-sfcwnd-fill': 'SFC_WND',    'gfa-sfcwnd-line': 'SFC_WND',
};

/** All GFA MapLibre layer ids (derived from HAZARD_BY_LAYER keys). */
export const GFA_LAYER_IDS = Object.keys(HAZARD_BY_LAYER);
